import $ from 'jquery';

export default class DynamicInstagram {
  constructor(section) {
    this.settings = section.data;
    this.onboarding = this.settings.onboarding;
    this.photoCount = this.settings.photoCount;
    this.accessToken = this.settings.accessToken;

    this.$el = $(section.el);
    this.$photoTemplate = $('[data-instagram-photo-template]', this.$el);
    this.$photoContainer = $('[data-instagram-photos]', this.$el);
    this.$contentPlaceholder = $('[data-instagram-content-placeholder]', this.$el);

    this.$photoTemplate.removeAttr('data-instagram-photo-template');
    this.$photoTemplate.remove();

    if (this.onboarding || !this.accessToken) {
      return;
    }

    this._getPhotos()
      .done((photos) => this._renderPhotos(photos))
      .fail(function(error) {
        console.warn(`Instagram: ${ error }`);
      });
  }

  _getPhotos() {
    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${ this.accessToken }&count=${ this.photoCount }&callback=`;
    const photoPromise = $.ajax(url, {
      dataType: 'jsonp',
    });

    return photoPromise.then(function(response) {
      if (response.meta.code != 200) {
        const error = `${ response.meta.error_message } (${ response.meta.error_type })`;
        return $.Deferred().reject(error).promise();
      }

      return response.data;
    });
  }

  _renderPhotos(photos) {
    const photoArray = [];

    // If we have more than 4 images, we want the nearest even number
    if (photos.length > 4 && photos.length % 2 == 1) {
      photos.pop();
    }

    this.$photoContainer.addClass(`instagram-photo-count-${ photos.length }`);

    for (let photo of photos) {
      const $template = this.$photoTemplate.clone();
      // Convert UNIX seconds to milliseconds and create Date object
      const date = new Date(photo.created_time * 1000);
      const dateOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      };
      const likes = photo.likes.count;
      const timestamp = date.toLocaleDateString(this.settings.locale, dateOptions);
      const caption = photo.caption && photo.caption.text ? photo.caption.text : '';
      const $link = $(`<a target="_blank" href="${ photo.link }"></a>`);
      const $photo = $(`<img src="${ photo.images.low_resolution.url }" srcset="${ photo.images.standard_resolution.url } 2x"/>`).wrap($link);

      $template
        .find('[data-instagram-photo-template-likes]')
        .append(likes)
        .removeAttr('data-instagram-photo-template-likes');

      if (caption !== '') {
        $template
          .find('[data-instagram-photo-template-caption]')
          .append(caption)
          .removeAttr('data-instagram-photo-template-caption');
      }

      $template
        .find('[data-instagram-photo-template-timestamp]')
        .append(timestamp)
        .removeAttr('data-instagram-photo-template-timestamp');
      $template.append($link);
      $template.append($photo);

      photoArray.push($template);
    }

    this.$contentPlaceholder.fadeOut().promise().then(() => {
      this.$photoContainer.append(photoArray);
      this.$contentPlaceholder.remove();
    });
  }
}
